import { useTranslation } from "react-i18next";
import ConfirmationModal from "@/components/layouts/ConfirmationModal";
import { TRANSLATION_KEY } from "@/components/global/Chat/components/dreamerReports/consts";

interface RemoveSavedReportModalProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  reportName: string;
  /** A scheduled report loses its schedule with it, which the copy says. */
  isScheduled: boolean;
  onConfirm: () => void;
}

/** Confirms taking a report out of the saved list, from chat or from a row. */
export const RemoveSavedReportModal: React.FC<RemoveSavedReportModalProps> = ({
  isOpen,
  setIsOpen,
  reportName,
  isScheduled,
  onConfirm
}) => {
  const { t } = useTranslation();
  const variant = isScheduled ? "scheduled" : "saved";

  return (
    <ConfirmationModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={t(`${TRANSLATION_KEY}.delete.confirmationTitle`)}
      confirmationText={t(
        `${TRANSLATION_KEY}.delete.confirmationText.${variant}`,
        {
          name: reportName || t(`${TRANSLATION_KEY}.untitled`)
        }
      )}
      submitButtonText={t(`${TRANSLATION_KEY}.delete.submit.${variant}`)}
      handleSubmit={onConfirm}
      data-test="delete-report-confirmation-modal"
    />
  );
};
